// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const isNonRetryableError = (obj) => {
    const key = 'nonRetryable';
    return obj && obj[key];
};
